/*
  Collection card color swatches.

  Markup is rendered by snippets/card-color-swatches.liquid:
    .js-color-swatches-wrapper          -> the card
      a.js-color-swatches-link          -> the image link (href is kept in sync)
      img.media--first / .media--second -> the card images
      .js-color-swatches input[type=radio][data-variant-image][data-variant-srcset][data-variant-link]

  Clicking (or tapping) a swatch swaps the card image and re-points the card
  link at the chosen variant. It never navigates on its own, and it does not
  react to hover — the image only changes on a deliberate click.
*/
(function () {
  function setActiveSwatch(input) {
    const group = input.closest('.js-color-swatches');
    if (!group) return;

    group.querySelectorAll('.card__color-swatch').forEach((label) => {
      label.classList.remove('card__color-swatch--active');
    });

    const label = input.closest('.card__color-swatch');
    if (label) label.classList.add('card__color-swatch--active');
  }

  function selectSwatch(input) {
    const wrapper = input.closest('.js-color-swatches-wrapper');
    if (!wrapper) return;

    input.checked = true;
    setActiveSwatch(input);

    const link = wrapper.querySelector('.js-color-swatches-link');
    if (link && input.dataset.variantLink) {
      link.setAttribute('href', input.dataset.variantLink);
    }

    const src = input.dataset.variantImage;
    if (!src) return;

    const primary = wrapper.querySelector('.media--first');
    if (!primary) return;

    // Already showing this image
    const current = primary.getAttribute('src') || '';
    if (current.split('?')[0] === src.split('?')[0]) return;

    // The hover image belongs to the previously shown color — drop it so the
    // card's hover crossfade doesn't reveal the wrong color.
    const secondary = wrapper.querySelector('.media--second');
    if (secondary) secondary.remove();

    primary.srcset = input.dataset.variantSrcset || '';
    primary.src = src;
  }

  function inputFrom(event) {
    const label = event.target.closest('.card__color-swatch');
    if (!label) return null;
    return label.querySelector('input[type="radio"]');
  }

  function onSelect(event) {
    const input = inputFrom(event);
    if (input) selectSwatch(input);
  }

  /* ----- Pagination (shown when a product has more than 3 colors) ----- */

  function updateNav(strip) {
    const wrap = strip.closest('.card__color-swatches-wrap');
    if (!wrap) return;

    const prev = wrap.querySelector('.card__swatch-nav--prev');
    const next = wrap.querySelector('.card__swatch-nav--next');
    if (!prev || !next) return;

    const max = strip.scrollWidth - strip.clientWidth;
    const pos = Math.abs(strip.scrollLeft);

    prev.disabled = pos <= 1;
    next.disabled = pos >= max - 1;
  }

  function onNavClick(event) {
    const button = event.target.closest('.card__swatch-nav');
    if (!button) return;

    event.preventDefault();

    const wrap = button.closest('.card__color-swatches-wrap');
    const strip = wrap && wrap.querySelector('.js-color-swatches');
    if (!strip) return;

    const rtl = getComputedStyle(strip).direction === 'rtl';
    const forward = button.classList.contains('card__swatch-nav--next');
    const page = strip.clientWidth;

    strip.scrollBy({ left: (forward ? page : -page) * (rtl ? -1 : 1) });
    setTimeout(() => updateNav(strip), 400);
  }

  function onStripScroll(event) {
    const strip = event.target;
    if (strip.classList && strip.classList.contains('js-color-swatches')) {
      updateNav(strip);
    }
  }

  // Delegated so cards added later (infinite scroll, filters, section reload) work too.
  document.addEventListener('click', onSelect);
  document.addEventListener('change', onSelect);
  document.addEventListener('click', onNavClick);
  document.addEventListener('scroll', onStripScroll, true);
})();
